import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, LOCALE_ID } from '@angular/core';
import { customFieldsBase } from '../custom-fields-base';

@Component({
    selector: 'app-custom-fields-dropdown-type',
    templateUrl: './custom-fields-dropdown-type.component.html',
    styleUrls: ['./custom-fields-dropdown-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsDropdownTypeComponent extends customFieldsBase {
    constructor(cdr: ChangeDetectorRef, @Inject(LOCALE_ID) localeId: string) {
        super(cdr, localeId);
    }
}
